export default function pointshopModule() {
  return import(/* webpackChunkName: "pointshop" */ '../pointshop')
    .then(({ default: Pointshop }) => {
      const pointshop = new Pointshop();
      return pointshop;
    })
    .catch(() => 'An error occurred while loading the component');
}
